import { PARAMETER_SUBSET_TYPE } from '@/constants/ParameterSubsetTypes.js';
import { operatorChoices } from '@/constants/Operators.js';

export const getDeviceModelOptionText = choice => {
    if (!choice) {
        return '';
    }
    if (choice.code && choice.name && choice.code !== choice.name) {
        return `${choice.code} - ${choice.name}`;
    }
    return choice.code || choice.name || String(choice.id ?? '');
};

export const getDeviceModelFilterOptionText = choice => {
    if (!choice) {
        return '';
    }
    if (choice.code && choice.name) {
        return `${choice.code} - ${choice.name}`;
    }
    return choice.code || choice.name || String(choice.id ?? '');
};

const deviceModelLabelSeparator = ' - ';

export const getDeviceModelSearchFilter = searchText => {
    const text = String(searchText ?? '');
    const separatorIndex = text.indexOf(deviceModelLabelSeparator);

    if (separatorIndex === -1) {
        return {
            search: {
                value: text,
                fields: { code: true, name: true },
            },
        };
    }

    const code = text.slice(0, separatorIndex).trim();
    const name = text.slice(separatorIndex + deviceModelLabelSeparator.length).trim();
    const nextFilter = {};

    if (code) {
        nextFilter.code_like = code;
    }
    if (name) {
        nextFilter.name_like = name;
    }

    return nextFilter;
};

export const getCollectionPointOptionText = choice => choice?.customId || choice?.name || String(choice?.id ?? '');

export const getDeviceOptionText = choice => choice?.serialNumber || choice?.customId || String(choice?.id ?? '');

export const getClientOptionText = choice => choice?.name || String(choice?.id ?? '');

export const getOperatorOptionText = id => operatorChoices.find(choice => String(choice.id) === String(id))?.name || String(id ?? '');

export const SUBSET_REFERENCE_DISPLAY = {
    [PARAMETER_SUBSET_TYPE.MODEL]: {
        reference: 'device-model',
        getLabel: getDeviceModelOptionText,
    },
    [PARAMETER_SUBSET_TYPE.CONTRACTOR]: {
        reference: 'contractor',
        getLabel: getClientOptionText,
    },
    [PARAMETER_SUBSET_TYPE.COLLECTION_POINT]: {
        reference: 'collection-point',
        getLabel: getCollectionPointOptionText,
    },
    [PARAMETER_SUBSET_TYPE.DEVICE]: {
        reference: 'device',
        getLabel: getDeviceOptionText,
    },
};
